import baseApi from "@/api/baseApi";
export default {
  add(form) {
    return baseApi.put('api-registration/v1/transport', form);
  },
  fetchSummary(slaughterWeeekId) {
    return baseApi.get(`api-registration/v1/transport/summary/${slaughterWeeekId}`);
  },
  update(form) {
    return baseApi.post('api-registration/v1/transport', form);
  },
  delete(id) {
    return baseApi.delete(`api-registration/v1/transport/${id}`);
  },
  move(form) {
    return baseApi.post('api-registration/v1/transport/move', form);
  },
  split(form) {
    return baseApi.post('api-registration/v1/transport/split', form);
  }
}
